// extracted by mini-css-extract-plugin
export default {"cta":"dH-z","disabled":"eH-z"};